import { AppId } from 'clickNgo/configs/app'
import { Market, Region } from 'clickNgo/configs/geo'
import { IContactFlags } from 'clickNgo/entities/contactFlag'
import { PartnerHierarchyType } from 'clickNgo/entities/partner/configs'
import { TExt } from 'clickNgo/models/utils'
import { Nullable } from 'cng-common/models/utils'

export enum ContactStatus {
  Active = 'Active',
  Inactive = 'Inactive',
  None = '',
}

export enum ContactWorkflowStatus {
  Done = 'Done',
  Draft = 'Draft',
  New = 'New',
  Rejected = 'Rejected',
  WIP = 'WIP',
  AwaitingCreation = 'AwaitingCreation',
  None = '',
}

export enum ContactSalutation {
  Sir = 'Sir',
  Prof = 'Prof.',
  Ms = 'Ms.',
  Mr = 'Mr.',
  Mrs = 'Mrs.',
  Miss = 'Miss.',
  Ing = 'Ing.',
  Dr = 'Dr.',
}

export enum ContactSeniority {
  Staff = 'Staff',
  MidManagement = 'Mid Management',
  LowManagement = 'Low Management',
  ExecutiveManagement = 'Executive Management',
  CLevel = 'C-Level',
}

export interface IContactAddress {
  addressLine1: string
  addressLine2: string
  addressLine3: string
  city: string
  country: string
  countryOfBusiness: string
  region: Region
  market: Market
  zipCode: string
}

export interface IContactCommon {
  email: string
  companyEmail: string
  firstName: string
  lastName: string
  mainPhoneNumber: string
  mainPhoneCode: string
  mobilePhoneNumber: string
  mobilePhoneCode: string
  workPhoneNumber: string
  workPhoneCode: string
  isNeverCall: boolean
  isNeverEmail: boolean
  emailPixels: 'Y' | 'N' | null
  communicationName: string
  gender: string
  organization: string
  preferredLanguage: string
  primaryJobRole: string[]
  professionalTitle: string
  seniority: string
  taxId: string
  url: string
}

export interface IContactAdditional {
  entryId?: number
  changeMindset: string
  competitors: string[]
  contactStatus: string
  facebookLink: string
  linkedInLink: string
  twitterLink: string
  whatsAppLink: string
  isHPChampion: boolean
  isHPHero: boolean
  isGDPR: boolean
  photo: string
  isPreferredContact: boolean
  relationshipStrength: string
  role: string
  modified: string
  modifiedBy: string
  createdBy: string
  jobTitle: string
  notCorporateEmailReason: string
  notCorporateEmailReasonComment: string
  salutation: string
}

export interface IContact extends IContactAdditional, IContactAddress, TExt<IContactCommon> {
  entryId?: number
  entryId375?: number
  entryId379?: number
  contactId: string
  newContactId: string
  partnerId: string
  newPartnerId: string
  parentPartnerId: string
  topPartnerId: string
  portalUserTypeCode: string
  hpRoles: string[]
  hpdContactGUID: string
  hpdPartnerGUID: string
  hpPassportProfileId: string
  hierarchyType: PartnerHierarchyType
  modifiedValues: (string | number | symbol)[]
  lastContactUpdateDate: string
  lastPartnerUpdateDate: string
  learnerId: string
  locationId: string
  loginId: string
  oldContactId: string
  oldPartnerId: string
  isSabaUser: boolean
  isSabaAdmin: boolean
  isPPA: boolean
  isPrimaryPartner: boolean
  isKeyContact: boolean
  profileTeamComment: string
  relinkingComment: string
  sourceRequester: string
  onboardingRequestId?: Nullable<number>
  source: string
  workflowStatus?: ContactWorkflowStatus
  lastRequest: string
  status: ContactStatus
  userCreatedDate: string
  userLastLoginDate: string
  userRowId: string
  userStatus: string
  appId: AppId
}

export type ContactState = {
  contactsById: Record<string, IContact>
  contactFlagsById: Record<string, IContactFlags>
  allContactIds: string[]
}
